import { render, staticRenderFns } from "./EventExportDetailed.vue?vue&type=template&id=1281d79c&"
import script from "./EventExportDetailed.vue?vue&type=script&lang=ts&"
export * from "./EventExportDetailed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports